import { useTranslate } from '@client/i18n/hooks';
import { CART_ITEM_ERROR_TYPE } from 'b2b-common/core/cart/api/CartTypes';

export enum PRODUCT_ERROR_TYPE {
  error = 'error',
  waning = 'warning',
}

type TranslatedErrors = {
  type: PRODUCT_ERROR_TYPE,
  label: string
};

export const useTranslateProductErrors = (
  errors: string[],
  availableQuantity: number,
): TranslatedErrors | null => {
  const t = useTranslate();

  if (!errors?.length) {
    return null;
  }

  const error = errors[0];

  switch (error) {
    case CART_ITEM_ERROR_TYPE.itemSoldOut:
      return {
        type: PRODUCT_ERROR_TYPE.waning,
        label: t(
          [
            'This product is sold out, only {availableQuantity} piece is available. The order quantity has been adjusted.',
            'This product is sold out, only {availableQuantity} pieces are available. The order quantity has been adjusted.',
            'quantity',
          ],
          { availableQuantity },
        ),
      };

    case CART_ITEM_ERROR_TYPE.itemMaxOrderQuantityExceeded:
      return {
        type: PRODUCT_ERROR_TYPE.waning,
        label: t(
          'This product has a defined maximum order quantity of {availableQuantity} pieces. The order quantity has been adjusted.',
          { availableQuantity },
        ),
      };

    case CART_ITEM_ERROR_TYPE.itemRemovedFromCart:
      return {
        type: PRODUCT_ERROR_TYPE.error,
        label: t('This product cannot be bought.'),
      };

    case CART_ITEM_ERROR_TYPE.priceChanged:
      return {
        type: PRODUCT_ERROR_TYPE.waning,
        label: t('This product\'s price has changed.'),
      };

    case CART_ITEM_ERROR_TYPE.itemOutsideOfCoreAssortment:
      return {
        type: PRODUCT_ERROR_TYPE.error,
        label: t('This product was not added to basket due to restrictions in assortment for this account.'),
      };

    default:
      return {
        type: PRODUCT_ERROR_TYPE.error,
        label: t('This product causes unrecognized error.'),
      };
  }
};
